import { useQuery } from "@tanstack/react-query";
import type { TApiODIN } from "@/apis/odin/apiODIN";
import { configKeys } from "@/queries/queryKeys";

export const createConfigQueryHooks = ({ apiODIN }: { apiODIN: TApiODIN }) => {
    const useGoogleMapsConfigQuery = (options?: { enabled?: boolean }) =>
        useQuery({
            queryKey: configKeys.googleMaps(),
            queryFn: async () => {
                const response = await apiODIN.getGoogleMapsConfig();
                return response.data;
            },
            enabled: options?.enabled,
        });

    return {
        useGoogleMapsConfigQuery,
    };
};

export type TConfigQueryHooks = ReturnType<typeof createConfigQueryHooks>;
